/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Personal_Data_Quick_Action_SublineInputs */

const de_account_personal_data_quick_action_subline = /** @type {(inputs: Account_Personal_Data_Quick_Action_SublineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name, Adresse und mehr`)
};

/** @type {(inputs: Account_Personal_Data_Quick_Action_SublineInputs) => LocalizedString} */
const en_account_personal_data_quick_action_subline = de_account_personal_data_quick_action_subline;

/**

* @param {Account_Personal_Data_Quick_Action_SublineInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const account_personal_data_quick_action_subline = /** @type {((inputs?: Account_Personal_Data_Quick_Action_SublineInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Personal_Data_Quick_Action_SublineInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_account_personal_data_quick_action_subline(inputs)
	return en_account_personal_data_quick_action_subline(inputs)
});